import {
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
   ShowModalEventInterceptor,
   ValidateFormEventInterceptor,
} from '@dreryk/react-components';

import {
   MedicalDocumentationPasswordDetailsShowModalInterceptor,
   MedicalDocumentationShareForm,
} from '~libs.desktop.shared.medical-documentation';
import {
   Prints,
   PrintsPatientSendEventInterceptor,
} from '~libs.desktop.shared.visit-medical-documents.print-from-visit';

import { VisitFormController } from '../../../visitForm.types';
import { visitDetailsTranslationKeys } from '../../../../../translations';

import { VisitSummaryConfirmActionEventInterceptor } from './VisitSummaryConfirmActionEventInterceptor';

type VisitSummaryConfirmAndShareShowModalEventInterceptorProps = Pick<VisitFormController, 'handleSubmit'> &
   Readonly<{
      children: JSX.Element;
      patientId: number;
      prints: Prints;
      visitId: number;
   }>;

export const VisitSummaryConfirmAndShareShowModalEventInterceptor = (
   props: VisitSummaryConfirmAndShareShowModalEventInterceptorProps
): JSX.Element => {
   return (
      <ShowModalEventInterceptor
         testId={'sharePatientDocumentation'}
         title={visitDetailsTranslationKeys.shareRecordsWithPatient}
         content={({ resolve, reject }) => (
            <MedicalDocumentationShareForm patientId={props.patientId}>
               {({ trigger, handleSubmit: handleMedicalDocumentationShareSubmit }) => {
                  return (
                     <>
                        <ValidateFormEventInterceptor trigger={trigger}>
                           <VisitSummaryConfirmActionEventInterceptor
                              handleSubmit={props.handleSubmit}
                              visitId={props.visitId}
                           >
                              <PrintsPatientSendEventInterceptor
                                 visitId={props.visitId}
                                 prints={props.prints}
                                 onMedicalDocumentationShareFormSubmit={handleMedicalDocumentationShareSubmit}
                              >
                                 {({ filePassword }) => (
                                    <MedicalDocumentationPasswordDetailsShowModalInterceptor
                                       filePassword={filePassword}
                                       title={visitDetailsTranslationKeys.createdAndSentPatientRecords}
                                       successMessage={
                                          visitDetailsTranslationKeys.sentDocumentationToPatientAndSmsMessageWithPassword
                                       }
                                    >
                                       <ModalConfirmButton label={visitDetailsTranslationKeys.send} onClick={resolve} />
                                    </MedicalDocumentationPasswordDetailsShowModalInterceptor>
                                 )}
                              </PrintsPatientSendEventInterceptor>
                           </VisitSummaryConfirmActionEventInterceptor>
                        </ValidateFormEventInterceptor>

                        <ModalCancelButton label={visitDetailsTranslationKeys.back} onClick={reject} />
                        <ModalCloseButton onClick={reject} />
                     </>
                  );
               }}
            </MedicalDocumentationShareForm>
         )}
         modalWidth={ModalWidth.NORMAL}
         shouldShowModal
         footerItemsHidden
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};
